var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', {
    staticClass: "v-data-table--default v-data-table--none-border-left",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "disable-sort": "",
      "items-per-page": 5
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "item.price",
      fn: function fn(_ref2) {
        var _value$format;

        var item = _ref2.item,
            value = _ref2.value;
        return [_c('div', {
          staticClass: "d-flex align-center justify-center"
        }, [_vm.isWinner(item) ? _c('v-chip', {
          staticClass: "rounded-0 justify-center px-6 py-0 mr-6",
          staticStyle: {
            "height": "22px",
            "pointer-events": "none"
          },
          attrs: {
            "color": "grey-ef",
            "text-color": "primary"
          }
        }, [_vm._v("최고가")]) : _vm._e(), _c('span', {
          class: {
            'font-weight-bold': _vm.isWinner(item)
          }
        }, [_vm._v(" " + _vm._s(value === null || value === void 0 ? void 0 : (_value$format = value.format) === null || _value$format === void 0 ? void 0 : _value$format.call(value)) + " ")])], 1)];
      }
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }